module.exports = __webpack_public_path__ + "img/framework_Image.0c9bc3b0.png";